let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bAXFw")).then(() => parcelRequire('7zTBI'));